import { routes } from '@/routing/routes'
import { generatePath, useNavigate } from 'react-router'

type RouteDefinition = {
  path: string
}

export function useNavigation() {
  const navigate = useNavigate()

  const navigateTo = (route: RouteDefinition, params = {}) => {
    const path = generatePath(route.path, params)
    navigate(path)
  }

  const navigateToListSpeci = (stationRecordNumber: string) => {
    navigateTo(routes.listSpeci, { stationRecordNumber })
  }
  const navigateToNewSpeci = (stationRecordNumber: string, speciId: string) => {
    navigateTo(routes.newSpeci, { stationRecordNumber, speciId })
  }
  const navigateToEditSpeci = (stationRecordNumber: string, speciId: string) => {
    navigateTo(routes.editSpeci, { stationRecordNumber, speciId })
  }
  const navigateToViewSpeci = (stationRecordNumber: string, speciId: string) => {
    navigateTo(routes.viewSpeci, { stationRecordNumber, speciId })
  }
  const navigateToWoolData = (stationRecordNumber: string) => {
    navigateTo(routes.woolData, { stationRecordNumber })
  }
  const navigateToWoolDataTab = (stationRecordNumber: string, woolDataTabValue: string) => {
    navigateTo(routes.woolDataTab, { stationRecordNumber, woolDataTabValue })
  }
  const navigateToListOffers = (stationRecordNumber: string) => {
    navigateTo(routes.listOffers, { stationRecordNumber })
  }
  const navigateToViewOffer = (stationRecordNumber: string, offerId: string) => {
    navigateTo(routes.viewOffer, { stationRecordNumber, offerId })
  }
  const navigateToLoggedOut = () => {
    navigateTo(routes.loggedOut)
  }
  const navigateToResources = () => {
    navigateTo(routes.resources)
  }
  const navigateToHome = () => {
    navigateTo(routes.home)
  }

  return {
    navigateToHome,
    navigateToListSpeci,
    navigateToNewSpeci,
    navigateToEditSpeci,
    navigateToViewSpeci,
    navigateToWoolData,
    navigateToWoolDataTab,
    navigateToListOffers,
    navigateToViewOffer,
    navigateToLoggedOut,
    navigateToResources,
  }
}
